import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout from '../../../components/auth/AuthLayout';

const SignupPanUpload = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mobile } = location.state || {};
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!mobile) {
      navigate('/signup', { replace: true });
    }
  }, [mobile, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!file) {
      toast.error('Please select a PAN image to upload');
      return;
    }

    setLoading(true);

    try {
      // TODO: Replace with actual API call to upload PAN
      // const response = await authServices.uploadPan(file);

      await new Promise(resolve => setTimeout(resolve, 1000));

      toast.success('PAN uploaded successfully');
      navigate('/signup/aadhaar', {
        state: { mobile, panUploaded: true }
      });
    } catch (error) {
      toast.error('Failed to upload PAN. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Upload PAN"
      subtitle="Upload a clear image of your PAN card to proceed"
      onBack={() => navigate('/signup/pan', { state: { mobile } })}
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">PAN Image</label>
          <input
            type="file"
            accept="image/*"
            className="form-input"
            onChange={(event) => setFile(event.target.files?.[0] || null)}
            required
          />
        </div>
        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Uploading...' : 'Upload & Continue'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default SignupPanUpload;


